import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PaginatedResponse } from '../types';

export const useHighlight = (data: PaginatedResponse<any> | null, dataAttr: string = 'data-deal-id') => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [highlightedId, setHighlightedId] = useState<number | null>(null);

  // Handle highlighting new entries
  useEffect(() => {
    const highlightParam = searchParams.get('highlight');
    if (highlightParam) {
      const id = parseInt(highlightParam, 10);
      if (!isNaN(id)) {
        setHighlightedId(id);

        // Scroll to the highlighted row after data loads
        setTimeout(() => {
          const element = document.querySelector(`[${dataAttr}="${id}"]`);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 100);

        // Remove highlight after 5 seconds
        const timer = setTimeout(() => {
          setHighlightedId(null);
          // Remove the highlight parameter from URL
          const newSearchParams = new URLSearchParams(searchParams);
          newSearchParams.delete('highlight');
          setSearchParams(newSearchParams, { replace: true });
        }, 5000);
        return () => clearTimeout(timer);
      }
    }
  }, [searchParams, setSearchParams, data]);

  return { highlightedId, setHighlightedId };
};
